import CategoryForm from "./categorycomponents/Form";

export default function CreateCategory() {
  return (
    <div>
      <CategoryForm />
    </div>
  );
}
